import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DateHelper } from '../../helpers/date.helper';

@Component({
  selector: 'shared-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrl: './date-range-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DateRangePickerComponent {
  @Input() from?: Date;
  @Input() to?: Date;
  @Input() minDate?: Date;
  @Input() maxDate?: Date;
  @Input() displayTime = true;

  @Output() fromChange = new EventEmitter<Date>();
  @Output() toChange = new EventEmitter<Date>();

  onFromChange(value?: Date): void {
    if (!this.displayTime) {
      // Normalize to start of day
      if (value) {
        this.from = DateHelper.startOfDay(value);
      }
    } else {
      this.from = value;
    }
    this.fromChange.emit(value);
    if (this.to && value && value > this.to) {
      this.to = value;
      this.toChange.emit(value);
    }
  }

  onToChange(value?: Date): void {
    if (!this.displayTime) {
      // Normalize to end of day
      if (value) {
        this.to = DateHelper.endOfDay(value);
      }
    } else {
      this.to = value;
    }
    this.toChange.emit(value);
    if (this.from && value && value < this.from) {
      this.from = value;
      this.fromChange.emit(value);
    }
  }
}
